import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { deleteCustomerAddress } from '../customers'

export default function useCustomerAddressDelete() {
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(deleteCustomerAddress, {
    onSuccess: () => {
      queryClient.invalidateQueries(`customerAddresses`)
      notification.success({
        message: 'Sucesso!',
        description: 'Remoção realizado com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível remover!'
      })
    }
  })

  return { mutate, isLoading }
}
